<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" :viewBox="`0 0 ${canvasWidth} ${canvasHeight}`" xmlns="http://www.w3.org/2000/svg">
      <rect ref="frame" id="Frame" x="0" y="0" :width="canvasWidth" :height="canvasHeight" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g ref="main">
          <foreignObject x="0" y="0" :width="canvasWidth" :height="canvasHeight">
            <picture>
              <source :srcset="`${publicPath}scenes/sun/Sun1-480w.jpg`" media="(max-width: 480px)">
              <source :srcset="`${publicPath}scenes/sun/Sun1-768w.jpg`" media="(max-width: 768px)">
              <source :srcset="`${publicPath}scenes/sun/Sun1-1280w.jpg`" media="(max-width: 1280px)">
              <source :srcset="`${publicPath}scenes/sun/Sun1-1920w.jpg`" media="(max-width: 1920px)">
              <img :style="{width: `100%`, height: `auto`}" :src="`${publicPath}scenes/sun/Sun1.jpg`" />
            </picture>
          </foreignObject>
          <g ref="flare" class="flare" style="isolation: isolate">
            <image opacity="0.5" width="766" height="766" x="746" y="517" :xlink:href="`${publicPath}scenes/sun/Sun2.png`"/>
            <image opacity="0.5" width="288" height="288" x="985" y="756" :xlink:href="`${publicPath}scenes/sun/Sun3.png`"/>
            <image opacity="0.5" width="288" height="288" x="985" y="756" :xlink:href="`${publicPath}scenes/sun/Sun4.png`"/>
            <image opacity="0.5" width="343" height="343" x="957" y="728" :xlink:href="`${publicPath}scenes/sun/Sun5.png`"/>
            <image opacity="0.2" width="478" height="478" x="890" y="661" :xlink:href="`${publicPath}scenes/sun/Sun6.png`"/>
          </g>
        </g>
      </g>
    </svg>
    <SceneDialogue
      :ref="`dialogue-1`"
      :width=".36"
      :tx="0.96" :ty="0.3"
      :fontSize="20"
      :className="`minion`">
      A few years before he passed away, Max rounded up all five brothers for
      a squaw dance. All of the brothers joked and acted as though they were
      young men, even though they were in their seventies and eighties.
    </SceneDialogue>
    <SceneDialogue
      :ref="`dialogue-2`"
      :width=".26"
      :tx="0.96" :ty="0.7"
      :fontSize="20"
      :className="`minion`">
      They were eating, joking, laughing, same as us. It was the last time all
      the Littlesalt men were together.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/sun/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import {TimelineLite, TweenLite, Power3} from "gsap"
import SceneDialogue from "../SceneDialogue.vue"

export default {
  extends: Template,
  mounted() {
    const main = this.$refs["main"]
    const d1 = this.$refs["dialogue-1"].$el
    const d2 = this.$refs["dialogue-2"].$el
    const flares = Array.from(this.$refs["flare"].querySelectorAll("image"))
    TweenLite.set(main, {opacity: 0})
    TweenLite.set(d1, {opacity: 0})
    TweenLite.set(d2, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(main, 3, {opacity: 1}))
    flares.forEach((f,i) => {
      const opacity = f.getAttribute("opacity")
      const x = `${-(50 - i * 5) * (i - 2)}%` // offset to -2
      const y = `${-(50 - i * 5) * (i - 2)}%`
      TweenLite.set(f, {opacity: 0, scale: 0, transformOrigin: "center center"})
      this.tl.add(TweenLite.to(f, 1, {
        scale: 0.66,
        opacity,
        x, y,
        ease: Power3.easeIn
      }), 2)
    })
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d2, 1, {opacity: 1}), "-=0.5")
  },
  methods: {
    enter() {this.tl.play()}
  },
  props: ["slide"]
}
</script>
